import { HttpClientModule } from '@angular/common/http';
import { NgModule, LOCALE_ID} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppLayoutModule } from './layout/app.layout.module';
import { httpInterceptorProviders } from './_helpers/http.interceptor';

import { DiagramModule, SymbolPaletteAllModule } from '@syncfusion/ej2-angular-diagrams';

import { OrderListModule } from 'primeng/orderlist';
import { TableModule } from "primeng/table";
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { EditorModule } from 'primeng/editor';
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { DropdownModule } from "primeng/dropdown";
import { ButtonModule as PrimeButtonModule } from "primeng/button";
import { PasswordModule } from "primeng/password";
import { CardModule } from "primeng/card";
import { MenuModule } from 'primeng/menu';
import { ChartModule } from "primeng/chart";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { MessagesModule } from "primeng/messages";
import { MessageModule } from "primeng/message";
import { BreadcrumbModule } from "primeng/breadcrumb";
import { CheckboxModule  as PrimeCheckboxModule} from "primeng/checkbox";
import { ListboxModule } from "primeng/listbox";
import { TreeModule } from "primeng/tree";
import { DialogModule as PrimeDialogModule} from 'primeng/dialog';

import { KeyFilterModule } from "primeng/keyfilter";
import { InputSwitchModule } from "primeng/inputswitch";
import { ToastModule } from "primeng/toast";
import { CarouselModule } from "primeng/carousel";
import { CalendarModule } from "primeng/calendar";
import { PanelModule } from "primeng/panel";
import { SelectButtonModule } from "primeng/selectbutton";
import { SpinnerModule } from "primeng/spinner";
import { InputMaskModule } from "primeng/inputmask";
import { TabViewModule } from "primeng/tabview";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { ToggleButtonModule } from "primeng/togglebutton";
import { AccordionModule } from "primeng/accordion";
import { FileUploadModule } from "primeng/fileupload";
import { RadioButtonModule as PrimeRadioButtonModule } from "primeng/radiobutton";
import { DataViewModule } from "primeng/dataview";
import { VirtualScrollerModule } from "primeng/virtualscroller";
import { InputNumberModule } from "primeng/inputnumber";
import { TooltipModule } from "primeng/tooltip";
import { MultiSelectModule } from "primeng/multiselect";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { SidebarModule } from "primeng/sidebar";
import { DragDropModule } from "primeng/dragdrop";
import { GalleriaModule } from "primeng/galleria";
import { SplitButtonModule } from "primeng/splitbutton";
import { ColorPickerModule as PrimeColorPickerModule} from "primeng/colorpicker";
import { TabMenuModule } from "primeng/tabmenu";
import { MegaMenuModule } from "primeng/megamenu";
import { OrganizationChartModule } from "primeng/organizationchart";
import { PickListModule } from "primeng/picklist";
import { SlideMenuModule } from "primeng/slidemenu";
import { BlockUIModule } from "primeng/blockui";
import { MenubarModule } from "primeng/menubar";
import { RippleModule } from "primeng/ripple";
import {FieldsetModule} from 'primeng/fieldset';
import {AutoCompleteModule} from 'primeng/autocomplete';
import { TreeTableModule } from 'primeng/treetable';
import {ChipsModule} from 'primeng/chips';
import {SplitterModule} from 'primeng/splitter';
import {DynamicDialogModule} from 'primeng/dynamicdialog';
import { TagModule } from 'primeng/tag';
import { SliderModule } from 'primeng/slider';

import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyPrimeNGModule } from '@ngx-formly/primeng';

import {FormlyDatepickerModule} from '@ngx-formly/primeng/datepicker';
import { SubpanelComponent } from './_helpers/components/subpanel/subpanel.component';

import { ClientiComponent } from './_components/clienti/clienti.component';
import { ClienteEditComponent } from './_components/clienti/cliente-edit/cliente-edit.component';
import { ProgettiComponent } from './_components/progetti/progetti.component';
import { ProgettoEditComponent } from './_components/progetti/progetto-edit/progetto-edit.component';
import { UsersComponent } from './_components/users/users.component';
import { UserEditComponent } from './_components/users/user-edit/user-edit.component';

import { DashboardComponent } from './_components/dashboard/dashboard.component';
import { RatingModule } from 'primeng/rating';
import { KnobModule } from 'primeng/knob';
import { MeterGroupModule } from 'primeng/metergroup';

import { TableComponent } from './_helpers/components/table/table.component';
import { RolesComponent } from './_components/roles/roles.component';
import { RoleEditComponent } from './_components/roles/role-edit/role-edit.component';
import { OpportunitiesComponent } from './_components/opportunities/opportunities.component';
import { OpportunityEditComponent } from './_components/opportunities/opportunity-edit/opportunity-edit.component';
import { ModelViewerComponent } from './_components/model/model-viewer/model-viewer.component';
import { ModelPdfComponent } from './_components/model/model-pdf/model-pdf.component';
import { DoctemplateEditComponent } from './_components/doctemplates/doctemplate-edit/doctemplate-edit.component';
import { DoctemplatesComponent } from './_components/doctemplates/doctemplates.component';
import { ModelDesignComponent } from './_components/model/model-design/model-design.component';
import { ContextMenuModule, ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { ColorPickerModule, NumericTextBoxModule, UploaderModule } from '@syncfusion/ej2-angular-inputs';
import { DropDownButtonModule } from '@syncfusion/ej2-angular-splitbuttons';
import { ButtonModule, CheckBoxModule, RadioButtonModule } from '@syncfusion/ej2-angular-buttons';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { TicketEditComponent } from './_components/tickets/ticket-edit/ticket-edit.component';
import { TicketsComponent } from './_components/tickets/tickets.component';
import { TranslationsComponent } from './_components/translations/translations.component';




@NgModule({
    declarations: [
        AppComponent,
        UsersComponent,
        UserEditComponent,
        DashboardComponent,
        TableComponent,
        RolesComponent,
        RoleEditComponent,
        ClientiComponent,
        ClienteEditComponent,
        TicketEditComponent,
        TicketsComponent,
        ProgettiComponent,
        SubpanelComponent,
        ProgettoEditComponent,
        OpportunitiesComponent,
        OpportunityEditComponent,
        ModelViewerComponent,
        ModelPdfComponent,
        DoctemplateEditComponent,
        DoctemplatesComponent,
        ModelDesignComponent,
        TranslationsComponent
        ],
    imports: [
        AppRoutingModule,
        AppLayoutModule,
        HttpClientModule,
        TableModule,
        TriStateCheckboxModule,
        OrderListModule,
        EditorModule,
        InputTextModule,
        InputTextareaModule,
        DropdownModule,
        PrimeButtonModule,
        PasswordModule,
        CardModule,
        MenuModule,
        ChartModule,
        ProgressSpinnerModule,
        MessagesModule,
        MessageModule,
        BreadcrumbModule,
        PrimeCheckboxModule,
        ListboxModule,
        TreeModule,
        PrimeDialogModule,
        KeyFilterModule,
        InputSwitchModule,
        ToastModule,
        CarouselModule,
        CalendarModule,
        PanelModule,
        SelectButtonModule,
        SpinnerModule,
        InputMaskModule,
        TabViewModule,
        ScrollPanelModule,
        ToggleButtonModule,
        AccordionModule,
        FileUploadModule,
        PrimeRadioButtonModule,
        DataViewModule,
        VirtualScrollerModule,
        InputNumberModule,
        TooltipModule,
        MultiSelectModule,
        ConfirmDialogModule,
        OverlayPanelModule,
        SidebarModule,
        DragDropModule,
        GalleriaModule,
        SplitButtonModule,
        PrimeColorPickerModule,
        TabMenuModule,
        MegaMenuModule,
        OrganizationChartModule,
        PickListModule,
        SlideMenuModule,
        BlockUIModule,
        MenubarModule,
        RippleModule,
        FieldsetModule,
        AutoCompleteModule,
        TreeTableModule,
        ChipsModule,
        SplitterModule,
        DynamicDialogModule,
        TagModule,
        FormsModule,
        RatingModule,
        KnobModule,
        MeterGroupModule,
        ReactiveFormsModule,
        FormlyPrimeNGModule,
        FormlyDatepickerModule,
        FormlyModule.forRoot(),
        DiagramModule,
        SymbolPaletteAllModule,ToolbarModule,DropDownButtonModule,
        ContextMenuModule,CheckBoxModule,DropDownListModule,NumericTextBoxModule,ColorPickerModule,
        SliderModule,RadioButtonModule,ButtonModule,UploaderModule,DialogModule
        
    ],
    providers: [
        {
            provide: LOCALE_ID,
            useValue: 'it-IT' // 'de-DE' for Germany, 'fr-FR' for France ...
        },
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        httpInterceptorProviders
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
